var _path, _path2, _circle;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 92,
    viewBox: "0 0 92 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.0968 43.9032C47.5368 43.3432 46.7921 43.0347 46.0001 43.0347C45.2081 43.0347 44.4633 43.3432 43.9033 43.9032C42.7471 45.0593 42.7471 46.9405 43.9033 48.0968C44.4633 48.6568 45.2081 48.9653 46.0001 48.9653C46.7921 48.9653 47.5368 48.6568 48.0968 48.0968C49.2531 46.9405 49.2531 45.0593 48.0968 43.9032Z",
    fill: "#7C7C7C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.306 35.6939L46 14L35.6939 35.6939L14 46L35.6939 56.3061L46 78L56.306 56.3061L78 46L56.306 35.6939ZM50.7463 50.7463C49.4785 52.014 47.7929 52.7122 46 52.7122C44.2071 52.7122 42.5215 52.0141 41.2537 50.7463C38.6366 48.1291 38.6366 43.8709 41.2537 41.2537C42.5215 39.986 44.2071 39.2878 46 39.2878C47.7928 39.2878 49.4785 39.9859 50.7463 41.2537C53.3634 43.8709 53.3634 48.1291 50.7463 50.7463Z",
    fill: "#7C7C7C"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 46,
    cy: 46,
    r: 44,
    stroke: "#7C7C7C",
    strokeWidth: 4
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.47a97d4105ece6955cbd0008ba5b27cd.svg";
export { ForwardRef as ReactComponent };